export const textFieldTheme = {
    background: {
        color: {
            base: (props) => props.theme.palette.surfaceAlt,
        },
    },
    border: {
        color: {
            base: (props) => props.theme.palette.secondaryAlt,
            none: (props) => props.theme.palette.secondaryAlt,
            error: (props) => props.theme.palette.error,
            focus: (props) => props.theme.palette.primary,
            hover: (props) => props.theme.palette.primary,
            success: (props) => props.theme.palette.success,
            warning: (props) => props.theme.palette.warning,
        },
        radius: (props) => props.theme.radius.lg,
        width: '1px',
    },
    color: {
        base: (props) => props.theme.palette.secondaryAlt,
    },
    input: {
        color: {
            base: (props) => props.theme.palette.contrastHigh,
            placeholder: (props) => props.theme.palette.secondaryAlt,
        },
        decorationMargin: (props) => props.theme.spacing.xxs,
        padding: {
            md: '0.6rem',
            xs: '0.375rem',
        },
    },
    outline: {
        color: {
            base: (props) => props.theme.palette.primary,
        },
    },
};
export const borderColorVariant = (props) => textFieldTheme.border.color[props.validationState];
